export const StorageType = {
	LOCAL: 'LOCAL',
	SESSION: 'SESSION',
	INDEXED_DB: 'INDEXED_DB',
} as const;

export type StorageType = (typeof StorageType)[keyof typeof StorageType];

/* -------------------------------------------------------------------------------------------------------------- */
export const TargetSyncStorageType = {
	[StorageType.LOCAL]: StorageType.LOCAL,
	[StorageType.INDEXED_DB]: StorageType.INDEXED_DB,
} as const;
export type TargetSyncStorageType = (typeof TargetSyncStorageType)[keyof typeof TargetSyncStorageType];

/* ------------------------------------------------  Cookies ------------------------------------------------ */
export type SameSite = 'Lax' | 'None' | 'Strict';

export interface CookieStorageOptions {
	expires?: number | Date;
	path?: string;
	domain?: string;
	secure?: boolean;
	sameSite?: SameSite;
}
